import React, { useState, useEffect } from 'react';
import {
    Spinner,
} from '@fluentui/react';
import { useParams } from "react-router-dom";
import useAxios from "axios-hooks";
import { axiosInstance } from '../../../../../api/config';
import SiteNotificationForm from './SiteNotificationForm';
import Toast from "../../../../Forms/Toast";
import FeatureSummary from "../../../../Util/FeatureSummary";
import env from "../../../../../env";

const AddEditNotification = () => {
    const { REACT_APP_API_BASE_URI } = env;
    let { notificationId } = useParams();
    const [notification, setNotification] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [submitResult, setSubmitResult] = useState({submitted: false, successful: false});

    const [{ loadingExisting }, executeExisting] = useAxios(
        {
            url: `2019-04-16/notifications/${notificationId}`,
            method: "GET",
            baseURL: REACT_APP_API_BASE_URI,
        },
        { axios: axiosInstance, manual: true }
    );

    const [{ loadingNew }, executeNew] = useAxios(
        {
            url: `2019-04-16/notifications/single-on-off`,
            method: "GET",
            baseURL: REACT_APP_API_BASE_URI,
        },
        { axios: axiosInstance, manual: true }
    );

    useEffect(() => {
        const getNotificationData = async () => {
            const responseExisting = await executeExisting({
                headers: { "Content-Type": "application/json" }
            });
            setNotification(responseExisting.data);
            setIsLoading(false)
        };

        const getNewNotificaitonOnOff = async () => {
            const responseNew = await executeNew({
                headers: { "Content-Type": "application/json" }
            });

            setNotification({
                activeFrom: new Date(),
                activeTo: new Date(),
                internalNotificationTitle: '',
                header: '',
                text: '',
                onOff: false,
                clients: responseNew.data.clients,
                coBrands: responseNew.data.coBrands,
                coBrandTags: responseNew.data.coBrandTags,
            });
            setIsLoading(false);
        };

        if (notificationId) {
            getNotificationData();
        } else if (!notificationId)
        {
            getNewNotificaitonOnOff();
        }
    }, [notificationId])

    if (isLoading)
        return <Spinner className="absolute-center" label="Loading..." />;
    return (
        <>
            <Toast show={submitResult.submitted && submitResult.successful} message="Saved!" onClose={() => setSubmitResult({ submitted: false, successful: false })} />
            <Toast show={submitResult.submitted && !submitResult.successful} message="An error has occured. Please refresh the page and try again. If the error persists, please try again later." onClose={() => setSubmitResult({ submitted: false, successful: false })} />
            <SiteNotificationForm notification={notification} isLoading={isLoading} addOrEdit={notificationId ? 'edit' : 'add'} setSubmitResult={setSubmitResult} />
            <FeatureSummary
                label="About Site Notifications"
                summary="Create or edit site notification banners that appear at the top of pages. Configure the notification title (internal), header text, body text, active date range, and visibility settings. Use on/off controls to target specific clients, cobrands, or cobrand tags."
            />
        </>
    );
};

export default AddEditNotification;
